export default [
  {
    path: "/purchases",
    name: "purchases",
    component: () => import("./pages/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Закупки",
      permissions: ["purchase:index"],
    },
  },
];
